import _ from "lodash";
import { ACTIONS, CO_BROWSE_SESSION_STATUS } from "UTILS/Constants";

/**
 * 初期状態値
 */
const initialState = {
  customerCoBrowsePermissionRequest: null,
  customerCoBrowsePermissionReply: null,
  participantLeftCustomerCoBrowseUniqueId: "",
  participantJoinedCustomerCoBrowseUniqueId: "",
  participantDeniedCustomerCoBrowseUniqueId: "",
  roomId: null,
  shareUrl: "",
  showCustomerCoBrowse: false,
  showTargetSiteModal: false,
  customerCoBrowseStarted: false,
  layoutCode: 3,
  appEmulationUrl: '',            // exCloserSV が返却してきた 共同閲覧コンテンツのURL
  appEmulationUrlForFollower: '', // exCloserSV が返却してきた 共同閲覧コンテンツのURL(フォロワー用)
};

/**
 * リデューサー本体
 * @param {*} state 現状態値
 * @param {*} action アクション(操作定数と入力値)
 * @returns 操作定数を見て何を行うか分岐し、現状態値と入力値を組み合わせて新状態値を返す
 */
export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_REQUEST:
      return { 
        ...state, 
        customerCoBrowsePermissionRequest: action.value, 
        customerCoBrowsePermissionReply: null
      };

    case ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_REPLY:
      return { ...state, customerCoBrowsePermissionReply: action.value };

    case ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_DATA:
      return{ ...state, roomId: action.roomId, shareUrl: action.shareUrl, customerCoBrowseStarted: true, layoutCode: action.layoutCode, serverName: action.serverName}

    case ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_STARTED:
      return { ...state, customerCoBrowseStarted: true };

    case ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_PERMISSION_DENIDED:
      return{ ...state, participantDeniedCustomerCoBrowseUniqueId: action.value }

    case ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_LEAVE_SESSION:
      return{ ...state, participantLeftCustomerCoBrowseUniqueId: action.value , endCustomerCBSession: false}

    case ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_JOIN_SESSION:
      return{ ...state, participantJoinedCustomerCoBrowseUniqueId: action.value }

    case ACTIONS.CUSTOMER_CO_BROWSE.SHOW_CUSTOMER_CO_BROWSE:
      return{...state, showCustomerCoBrowse: action.value}

    case ACTIONS.LEAVE_SESSION_LOCAL:
      let resetState = _.cloneDeep(initialState);
      if(state.showCustomerCoBrowse){
        resetState.endCustomerCBSession = true
        resetState.showCustomerCoBrowse = state.showCustomerCoBrowse,
        resetState.roomId = state.roomId,
        resetState.shareUrl = state.shareUrl
      }
      return resetState

    case ACTIONS.CUSTOMER_CO_BROWSE.SHOW_TARGET_SITE_SELECTION_MODAL:
      return { ...state, showTargetSiteSelectionModal: action.value }

    case ACTIONS.SET_END_SESSION_FLAG:

    case ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_END_SESSION:
      return initialState

    case ACTIONS.CUSTOMER_CO_BROWSE.SET_APP_EMULATION_URL:
      return {...state, appEmulationUrl: action.value}

    case ACTIONS.CUSTOMER_CO_BROWSE.SET_APP_EMULATION_URL_FOR_FOLLOWER:
      return {...state, appEmulationUrlForFollower: action.value}

    // 2022-12-01 ADD
    case ACTIONS.CUSTOMER_CO_BROWSE.SET_LAYOUT_CODE:
      return {...state, layoutCode: action.value}

    default:
      return state;
  }
}
